module.exports = __webpack_public_path__ + "static/media/073-hourglass.062f5451.svg";